import { useManagementTranslations } from 'core/Hooks';
import { Alert, ButtonMantine, Modal, Stack, Text } from 'ui';

import {
  ModalTitleWithBackButton,
  useSetupPeerPageModalProvider,
} from './SetupPeerPageModalProvider';
import { SetupPeerPageStepper } from './SetupPeerPageStepper';

const SetupCompleteModal = () => {
  const { opened, closeAllModals, meta } = useSetupPeerPageModalProvider({
    id: 'complete',
  });

  const { t } = useManagementTranslations({
    storeId: meta.campaign.cause_id,
    storeItemId: meta.campaign.uuid,
  });

  return (
    <Modal
      opened={opened}
      onClose={closeAllModals}
      title={<ModalTitleWithBackButton>Setup Complete</ModalTitleWithBackButton>}
    >
      <Stack gap="lg">
        <SetupPeerPageStepper activeStep={3} />
        <Text fz="sm">
          Your {t('participant')} page is all set! You can start sharing your page to spread the
          word and make an impact.
        </Text>
        <Alert type="info-blue">
          Remember, you can go back and edit your image, description, and notification preferences
          anytime.
        </Alert>
      </Stack>
      <Modal.AffixedFooter>
        <ButtonMantine fullWidth onClick={closeAllModals}>
          Okay
        </ButtonMantine>
      </Modal.AffixedFooter>
    </Modal>
  );
};

export { SetupCompleteModal };
